<template>
    <div class="full-width" v-if="null != yearList && yearList.length > 0">
        <span :class="currYear == v ? 'record-select-box' : 'record-none-select-box'" v-for="(v, i) in yearList" :key="i + new Date().getTime()" @click="clickFunc(v)">{{v}}</span>
    </div>
</template>

<script setup>

    const props = defineProps(["yearList", "currYear"])
    const emits = defineEmits(["clickYear"])

    function clickFunc(year) {
        emits("clickYear", year)
    }

</script>

<style scoped>
    .record-select-box {
        cursor: pointer;
        display: inline-block;
        font-size: 18px;
        margin-right: 10px;
        color: #e83f33;
    }

    .record-none-select-box {
        cursor: pointer;
        display: inline-block;
        font-size: 18px;
        margin-right: 10px;
        color: #606266;
    }

    .full-width {
        width: 100%;
        text-align: left;
    }
</style>